import { createSelector } from "reselect";
import { Selectors, State } from "@grandvisionhq/auth";
import { Util } from "@grandvisionhq/forms";
import { getMyAccount } from "../../selectors.js";
const getProfile = createSelector(
  getMyAccount,
  Selectors.getAuth,
  (myAccount, auth) => State.isLoggedIn(auth) ? myAccount.profile : void 0
);
const getForms = createSelector(
  getProfile,
  (profile) => profile && profile.forms || {}
);
const getFormData = createSelector(
  getForms,
  (forms) => forms ? {
    personalDetails: forms.personalDetails ? Util.getValuesFromState(forms.personalDetails.state.formState) : {},
    billingAddress: forms.billingAddress ? Util.getValuesFromState(forms.billingAddress.state.formState) : {},
    preferredStore: forms.preferredStore ? Util.getValuesFromState(forms.preferredStore.state.formState) : {}
  } : {}
);
const getPersonalDetails = createSelector(getForms, (forms) => forms?.personalDetails);
const getBillingAddress = createSelector(getForms, (forms) => forms?.billingAddress);
const getFormValidity = createSelector(
  getForms,
  (forms) => ({
    personalDetails: forms && forms.personalDetails ? forms.personalDetails.state.formValid : false,
    billingAddress: forms && forms.billingAddress ? forms.billingAddress.state.formValid : false,
    preferredStore: forms && forms.preferredStore ? forms.preferredStore.state.formValid : false
  })
);
export {
  getBillingAddress,
  getFormData,
  getFormValidity,
  getForms,
  getPersonalDetails,
  getProfile
};
//# sourceMappingURL=selectors.js.map
